





















































import { Component, Prop, Emit } from "vue-property-decorator";
import Vue from "vue";
// import CardModalPemeriksaan from "../components/CardModalPemeriksaan.vue";
import CardPemeriksaanDokter from "../components/CardPemeriksaanDokter.vue";
import CardPemeriksaanPerawat from "../components/CardPemeriksaanPerawat.vue";
import { userModule } from "@/store/modules/user";
import storeListPasienRalan from "@/store/modules/new/ListPasienRalan";
import { SoapResponseItem } from "@/types/soap";

@Component({
  components: {
    CardPemeriksaanDokter,
    CardPemeriksaanPerawat
    // CardModalPemeriksaan
  }
})
export default class CardPemeriksaan extends Vue {
  name: CardPemeriksaan;
  @Prop() readonly btn!: string;
  @Prop() readonly title!: string;
  @Prop() readonly time!: string;
  @Prop() readonly errPx!: string;
  @Prop() readonly hidden!: false;
  @Prop() readonly dt: object;
  @Prop() modeCopy: boolean;
  // page = 0
  page = "tab-soap";
  register = "";
  data = {};

  // modalOpen = false
  // data:object

  // @Emit("addSOAP") //DaftarPasien.vue
  // addPemeriksaan() {
  //   this.register = this.dt["register"];
  //   this.data = {
  //     register: this.dt["register"],
  //     page: "page-soap",
  //     rm: this.dt["pasien"].rm,
  //   };
  //   return this.data;
  // }

  addPemeriksaan() {
    storeListPasienRalan.SET_INPUT_PERIKSA_ACTIVE_ROW(true);
  }

  mounted() {}

  get stateuser() {
    return userModule.user;
  }

  get selectedPasien() {
    return storeListPasienRalan.activeRow;
  }

  get soapList(): SoapResponseItem[] {
    const soapDokter =
        this.dt && this.dt["soap_dokter"] ? this.dt["soap_dokter"] : [],
      soapPerawat =
        this.dt && this.dt["soap_perawat"] ? this.dt["soap_perawat"] : [];

    return [...soapDokter, ...soapPerawat].sort((a, b) => {
      return (
        new Date(a.examined_at).getTime() - new Date(b.examined_at).getTime()
      );
    });
  }

  copyS(value) {
    this.$emit("copyS", value);
  }
  copyO(value) {
    this.$emit("copyO", value);
  }
  copyA(value) {
    this.$emit("copyA", value);
  }
  copyP(value) {
    this.$emit("copyP", value);
  }
  reloadPx() {
    this.$emit("reloadPx", "");
  }

  // pemeriksaanPerawat(item){
  //     console.log(item.perawat)
  //     // this.data=item.perawat
  //     // this.modalOpen = true
  // }
}
